import { AdminConfiguration } from '@centecomm/admin-config-service';
import { useCurrentUser } from '@centecomm/portal-service-react';
import useSettingsFromState from 'State/Settings/Hooks/useSettingsFromState';

// eslint-disable-next-line import/prefer-default-export
export const useIsIdtStorageEnabled = (occupantId: number | undefined | null): boolean => {
    const { getOccupantCompanyId } = useCurrentUser();
    const { settings } = useSettingsFromState<AdminConfiguration>();
    const documentManagementSettings = settings?.documentManagement;

    if (documentManagementSettings && documentManagementSettings.storageType === 0) {
        return true;
    }

    if (occupantId) {
        const companyId = getOccupantCompanyId(occupantId ?? 0) ?? 0;
        return documentManagementSettings?.companyStorageTypes?.[companyId]?.storageType === 0;
    }

    return true;
};
